/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'vs';
const componentName = 'vs-enhanced-vh-child-hosts';
const prefix = `${moduleName}.${componentName}`;

export const domainLabel = `${prefix}.domainLabel`;
export const hostInputLabel = `${prefix}.hostInputLabel`;
export const addMatchButtonLabel = `${prefix}.addMatchButtonLabel`;
export const addDomainButtonLabel = `${prefix}.addDomainButtonLabel`;
export const removeDomainTitle = `${prefix}.removeDomainTitle`;
export const hostInputPlaceholder = `${prefix}.hostInputPlaceholder`;

export const ENGLISH = {
    [domainLabel]: 'Domain',
    [hostInputLabel]: 'Host',
    [addMatchButtonLabel]: 'Add Match',
    [addDomainButtonLabel]: 'Add Domain',
    [removeDomainTitle]: 'Remove Domain',
    [hostInputPlaceholder]: 'Host',
};
